module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedUltraBoldItalic.0344866.woff";